var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 18,
    viewBox: "0 0 60 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.127 17.7295L24.1679 0.291382H29.0376L25.9861 17.7295H21.127Z",
    fill: "#4C4C4C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.6257 0.717919C42.6581 0.384971 41.1377 0 39.2663 0C34.4497 0 31.0792 2.36185 31.0579 5.75376C31.0366 8.26127 33.4715 9.65549 35.311 10.4983C37.2036 11.3619 37.8415 11.8925 37.8203 12.6624C37.8203 13.8382 36.3211 14.3688 34.9176 14.3688C32.9718 14.3688 31.9404 14.1087 30.3455 13.4532L29.7076 13.1619L29.0483 17.0636C30.1754 17.5734 32.27 17.9792 34.4604 18C39.5747 18 42.8708 15.6694 42.9239 12.0277C42.9452 10.0509 41.648 8.5422 38.841 7.28324C37.1398 6.49249 36.1084 5.96185 36.1084 5.13988C36.1084 4.39075 36.9909 3.62081 38.8835 3.62081C40.4784 3.6 41.6374 3.93295 42.5199 4.29711L42.9665 4.4948L43.6257 0.717919Z",
    fill: "#4C4C4C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.0871 0.312134H52.3232C51.1642 0.312134 50.2817 0.624273 49.7607 1.75838L42.5518 17.7607H47.6448C47.6448 17.7607 48.4848 15.5965 48.6762 15.1387C49.2397 15.1387 54.1839 15.1387 54.8963 15.1387C55.0451 15.7422 55.4917 17.7607 55.4917 17.7607H59.9893L56.0871 0.312134ZM50.0903 11.5491C50.4837 10.5607 52.0361 6.69017 52.0361 6.69017C51.9829 6.74219 52.4295 5.68092 52.674 5.02543L52.993 6.51329C52.993 6.51329 53.9287 10.6751 54.1201 11.5387H50.0903V11.5491Z",
    fill: "#4C4C4C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0653 0.312134L12.2912 12.1942L11.8021 9.79075C10.9196 7.00231 8.13387 3.99537 5.06104 2.4763L9.40979 17.7295H14.5454L22.2009 0.312134H17.0653Z",
    fill: "#4C4C4C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.88942 0.291321H0.0531632L0 0.676292C6.07124 2.12253 10.1329 5.60808 11.8022 9.80115L10.0797 1.78959C9.78203 0.676292 8.95268 0.332939 7.88942 0.291321Z",
    fill: "#A5A5A5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.3935125c.svg";
export { ForwardRef as ReactComponent };